import { Option } from '~/shared/config/constants'

export const filterOptions = <T extends Option>(
  search: string | undefined,
  options: T[],
): T[] => {
  if (!search) return options

  const normalizedQuery = search.toLowerCase()
  return options.filter((option) =>
    option.label.toLowerCase().includes(normalizedQuery),
  )
}
